import React from 'react';
import { Eye, EyeClosed } from '../../../../foundations/icons';
import { Typography } from '../../../../foundations/typography';
import styles from './PasswordVisibilityToggle.module.scss';
export var PasswordVisibilityToggle = function (_a) {
    var inputId = _a.inputId, passwordVisible = _a.passwordVisible, setPasswordVisible = _a.setPasswordVisible;
    return (React.createElement("div", { className: styles.container },
        React.createElement("button", { "aria-checked": passwordVisible || false, "aria-controls": inputId, className: styles.toggle, onClick: function () {
                setPasswordVisible(!passwordVisible);
            }, role: "switch", type: "button" },
            React.createElement(Typography, { className: styles.content, element: "span", noMargins: true, styleAs: "paragraphHeading" }, passwordVisible ? (React.createElement(React.Fragment, null,
                React.createElement(EyeClosed, { className: styles.icon }),
                "Hide password")) : (React.createElement(React.Fragment, null,
                React.createElement(Eye, { className: styles.icon }),
                "Show password")))),
        React.createElement("span", { "data-testid": "toogle-alert-text", className: "sr-only", "aria-live": "polite" }, passwordVisible ? 'Password visible' : 'Password hidden')));
};
//# sourceMappingURL=PasswordVisibilityToggle.js.map